import { lazy } from 'react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { useAuthContext } from './context/AuthContext.jsx'
import PageSuspense from './components/molecules/PageSuspense/index.jsx'
import OffsetDetails from './pages/OffsetDetails.jsx'
import Dashboard from './pages/DashboardManagement.jsx'
import Root from './pages/Root.jsx'
import ErrorPage from './pages/Error.jsx'
import HttpError from './utils/HttpError.js'
import { ErrorBoundary } from 'react-error-boundary'
import Reports from './pages/Reports.jsx'
const AdminProfile = lazy(() => import('./pages/AdminProfile'))
const UserKYC = lazy(() => import('./pages/UserKYC'))
const ViewKYC = lazy(() => import('./pages/ViewKYC.jsx'))
const Home = lazy(() => import('./pages/Home'))
const Login = lazy(() => import('./pages/Login'))
const UserLogin = lazy(() => import('./pages/UserLogin'))
const Retirements = lazy(() => import('./pages/Retirements.jsx'))
const TransferRequest = lazy(() => import('./pages/TransferRequest.jsx'))
const MarketPlace = lazy(() => import('./pages/MarketPlace.jsx'))
const TokenHistory = lazy(() => import('./pages/TokenHistory.jsx'))
const Transactions = lazy(() => import('./pages/Transactions.jsx'))
const ContactUs = lazy(() => import('./pages/ContactUs.jsx'))
const Inquire = lazy(() => import('./pages/Inquire.jsx'))
const Subscription = lazy(() => import('./pages/Subscription.jsx'))
const StaticPages = lazy(() => import('./pages/StaticPages.jsx'))
const Roles = lazy(() => import('./pages/Roles.jsx'))
const UserList = lazy(() => import('./pages/UserList.jsx'))
const Projects = lazy(() => import('./pages/Projects'))
const ViewProject = lazy(() => import('./pages/ViewProject.jsx'))
const RetirementDetails = lazy(() => import('./pages/Retirementdetails.jsx'))
const TransferDetails = lazy(() => import('./pages/Transferdetails.jsx'))
const TokenDetail = lazy(() => import('./pages/TokenDetail.jsx'))
const UserDetails = lazy(() => import('./pages/UserDetails.jsx'))
const TransactionDetails = lazy(() => import('./pages/TransactionDetails.jsx'))
const AccountManagement = lazy(() => import('./pages/AccountManagement.jsx'))
const AccountDetails = lazy(() => import('./pages/AccountDetails.jsx'))
const Coupon = lazy(() => import('./pages/Coupon.jsx'))
const News = lazy(() => import('./pages/News.jsx'))
const AllNews = lazy(() => import('./pages/AllNews.jsx'))
const AllBlogs = lazy(() => import('./pages/AllBlogs.jsx'))
const NewsDescription = lazy(() => import('./pages/NewsDescription'))
// const BlogsDescription = lazy(() => import('./pages/BlogsDescription'))
const DepositWithdraw = lazy(() => import('./pages/WalletManage.jsx'))
const EditStaticPage = lazy(() => import('./pages/EditStaticPage.jsx'))
const WalletTransactionDetails = lazy(() =>
  import('./pages/WalletTransactionDetails.jsx')
)
const ContactUsDescription = lazy(() =>
  import('./pages/ContactUsDescription.jsx')
)

function App () {
  const { authUser } = useAuthContext()
  const router = createBrowserRouter([
    { path: '/login', element: authUser ? <Navigate to='/' /> : <Login /> },
    {
      path: '/user-login',
      element: (
        <PageSuspense>
          {' '}
          <UserLogin />
        </PageSuspense>
      )
    },
    {
      path: '/',
      element: authUser ? (
        <ErrorBoundary fallbackRender={ErrorPage}>
          <Root />
        </ErrorBoundary>
      ) : (
        <Navigate to='/login' />
      ),

      children: [
        {
          index: true,
          element: (
            <PageSuspense>
              <Home />
            </PageSuspense>
          )
        },
        // {
        //   path: '/user-login',
        //   element: (
        //     <PageSuspense>
        //       {' '}
        //       <UserLogin />
        //     </PageSuspense>
        //   )
        // },
        {
          path: '/user-profile',
          element: (
            <PageSuspense>
              <AdminProfile />
            </PageSuspense>
          )
        },
        {
          path: '/projects',
          element: (
            <PageSuspense>
              <Projects />
            </PageSuspense>
          )
        },
        {
          path: '/project/:projectId',
          element: (
            <PageSuspense>
              <ViewProject />
            </PageSuspense>
          )
        },
        {
          path: '/contact-us/:id',
          element: (
            <PageSuspense>
              <ContactUsDescription />
            </PageSuspense>
          )
        },

        {
          path: '/news-and-blogs',
          element: (
            <PageSuspense>
              <News />
            </PageSuspense>
          )
        },
        {
          path: 'news-description/:id',
          element: (
            <PageSuspense>
              <NewsDescription />
            </PageSuspense>
          )
        },
        {
          path: 'blogs-description/:id',
          element: (
            <PageSuspense>
              <NewsDescription />
            </PageSuspense>
          )
        },
        {
          path: '/all-news',
          element: (
            <PageSuspense>
              <AllNews />
            </PageSuspense>
          )
        },
        {
          path: '/all-blogs',
          element: (
            <PageSuspense>
              <AllBlogs />
            </PageSuspense>
          )
        },
        {
          path: '/coupons',
          element: (
            <PageSuspense>
              <Coupon />
            </PageSuspense>
          )
        },

        {
          path: '/user-kyc',
          element: (
            <PageSuspense>
              <UserKYC />
            </PageSuspense>
          )
        },
        {
          path: '/userkyc-details/:documentId',
          element: (
            <PageSuspense>
              <ViewKYC />
            </PageSuspense>
          )
        },
        {
          path: 'transactions',
          element: (
            <PageSuspense>
              <Transactions />
            </PageSuspense>
          )
        },

        {
          path: '/transaction-details/:transactionId',
          element: (
            <PageSuspense>
              <TransactionDetails />
            </PageSuspense>
          )
        },

        {
          path: 'retirements',
          element: (
            <PageSuspense>
              <Retirements />
            </PageSuspense>
          )
        },
        {
          path: '/retirement-details/:typeOfRequest/:retId',
          element: (
            <PageSuspense>
              <RetirementDetails />
            </PageSuspense>
          )
        },
        {
          path: '/reports',
          element: (
            <PageSuspense>
              <Reports />
            </PageSuspense>
          )
        },
        {
          path: '/wallet-manage/Deposit-Withdraw',
          element: (
            <PageSuspense>
              <DepositWithdraw />
            </PageSuspense>
          )
        },
        {
          path: '/deposit-withdraw-details/:reqId',
          element: (
            <PageSuspense>
              <WalletTransactionDetails />
            </PageSuspense>
          )
        },
        {
          path: '/transfer-requests',
          element: (
            <PageSuspense>
              <TransferRequest />
            </PageSuspense>
          )
        },
        {
          path: '/transfer-details/:reqId',
          element: (
            <PageSuspense>
              <TransferDetails />
            </PageSuspense>
          )
        },
        {
          path: 'forms/contact-us',
          element: (
            <PageSuspense>
              <ContactUs />
            </PageSuspense>
          )
        },
        {
          path: 'forms/inquire',
          element: (
            <PageSuspense>
              <Inquire />
            </PageSuspense>
          )
        },
        {
          path: 'forms/subscription',
          element: (
            <PageSuspense>
              <Subscription />
            </PageSuspense>
          )
        },
        {
          path: 'marketplace-users',
          element: (
            <PageSuspense>
              <MarketPlace />
            </PageSuspense>
          )
        },

        {
          path: '/marketplace-user/:id',
          element: (
            <PageSuspense>
              <UserDetails />
            </PageSuspense>
          )
        },

        {
          path: '/wallet-manage/account-management',
          element: (
            <PageSuspense>
              <AccountManagement />
            </PageSuspense>
          )
        },

        {
          path: '/account-details',
          element: (
            <PageSuspense>
              <AccountDetails />
            </PageSuspense>
          )
        },

        {
          path: 'token-history',
          element: (
            <PageSuspense>
              <TokenHistory />
            </PageSuspense>
          )
        },

        {
          path: 'setting/static-pages',
          element: (
            <PageSuspense>
              <StaticPages />
            </PageSuspense>
          )
        },
        {
          path: 'setting/static-pages/EditStaticPage',
          element: (
            <PageSuspense>
              <EditStaticPage />
            </PageSuspense>
          )
        },

        {
          path: 'setting/roles',
          element: (
            <PageSuspense>
              <Roles />
            </PageSuspense>
          )
        },
        {
          path: 'setting/users',
          element: (
            <PageSuspense>
              <UserList />
            </PageSuspense>
          )
        },
        {
          path: '/tokenTrail/:id',
          element: (
            <PageSuspense>
              <TokenDetail />
            </PageSuspense>
          )
        },
        {
          path: 'setting/offsetgo-details',
          element: (
            <PageSuspense>
              <OffsetDetails />
            </PageSuspense>
          )
        },
        {
          path: 'setting/dashboard',
          element: (
            <PageSuspense>
              <Dashboard />
            </PageSuspense>
          )
        },

        {
          path: '*',
          element: (
            <PageSuspense>
              <ErrorPage error={new HttpError(404, 'Page not found')} />
            </PageSuspense>
          )
        }
      ]
    }
  ])
  return (
    <main className='font-spaceGrotesk bg-[#F4F6FA] min-h-screen flex max-w-screen-2xl mx-auto'>
      <RouterProvider router={router} />
      <Toaster />
    </main>
  )
}

export default App
